import { AutoSuggestionItemProps } from "@vebox/etui-core";
import { VeboxModels } from "../../../../../../types/veboxModels";
import { VeBoxEquipmentFilters } from "../../../data/models/VeBoxEquipmentFilters";

export const mapEquipmentModelsIntoAutoSuggestions = (
	equipmentModels: VeboxModels.EquipmentModel[],
): AutoSuggestionItemProps[] => {
	return equipmentModels.map((equipmentModel: VeboxModels.EquipmentModel) => {
		return {
			label: `${equipmentModel?.name}${equipmentModel?.customName && equipmentModel?.customName === equipmentModel?.name ? "" : ` (${equipmentModel?.customName})`}`,
			value: equipmentModel?.guid,
			data: equipmentModel,
		};
	});
};

export const createKeyFilter = (key: string): VeBoxEquipmentFilters => {
	return {
		equipmentFiltersCategory: {
			code: key,
		},
	};
};

export const createModelFilter = (
	modelGuids: string[],
): VeBoxEquipmentFilters => {
	return {
		equipmentFiltersCategory: {
			equipmentModelGuids: modelGuids,
		},
	};
};
